module.exports = __webpack_public_path__ + "img/erweima.91007584.png";